import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { StorageService } from '../_services/storage.service';

import { MOCK_API_RESPONSE_TOKEN, MOCK_API_RESPONSE_GENERIC, MOCK_CURL_RESPONSE_GENERIC, MOCK_CURL_RESPONSE_TOKEN } from '../../assets/api-explorer-mock/api-explorer-dummy-response';

const { DEVELOPER_PORTAL_URL } = environment;

@Injectable({
  providedIn: 'root'
})
export class ApiExplorerService {
  constructor(
    private readonly http: HttpClient,
    private readonly storageService: StorageService,
    private readonly router: Router
  ) { }

  // getApiData(apiName: string): Observable<any> {
  //   // const url = `${DEVELOPER_PORTAL_URL}/api-explorer/${apiName}`;
  //   // return this.http.get(url).pipe(catchError(this.handleError()));
  // }

  // getApiData(apiName: string): Observable<any> {
  //   // NOTE: Using mock data for now,that's why checking for 'token' api name or generic api name
  //   const mock = apiName === 'token' ? MOCK_API_RESPONSE_TOKEN : MOCK_API_RESPONSE_GENERIC;
  //   return of(mock);
  // }
  
  runCurlRequest(apiName: string): Observable<any> {
    const mock = apiName === 'token' ? MOCK_CURL_RESPONSE_TOKEN.curl_req_response : MOCK_CURL_RESPONSE_GENERIC.curl_req_response;
    return of(mock);
  }

  callApi(options: {
    url: string;
    method: string;
    headers: { [key: string]: string };
    queryParams: { [key: string]: string };
    body: any | null;
    /** When true, omit Content-Type so the browser sets the multipart boundary. */
    isMultipart?: boolean;
    responseType?: 'json' | 'blob';
  }): Observable<{ status: number; statusText: string; body: any; blob?: Blob; fileName?: string }> {
    const { url, method, headers, queryParams, body, isMultipart, responseType } = options;

    let httpParams = new HttpParams();
    Object.entries(queryParams).forEach(([k, v]) => {
      if (v !== undefined && v !== '') httpParams = httpParams.set(k, v);
    });

    // Multipart must not force application/json — the browser sets multipart/form-data + boundary.
    const headerBag: { [key: string]: string } = { ...headers };
    if (!isMultipart && !(body instanceof FormData)) {
      headerBag['Content-Type'] = headerBag['Content-Type'] || 'application/json';
    } else {
      delete headerBag['Content-Type'];
    }
    const httpHeaders = new HttpHeaders(headerBag);
    const wantsBlob = responseType === 'blob';

    // Cast needed: when responseType is a runtime 'blob'|'json' union, HttpClient
    // overloads do not narrow to HttpResponse and fall through to ArrayBuffer.
    const upperMethod = method.toUpperCase();
    const req$ = this.http.request(upperMethod, url, {
      body: upperMethod === 'GET' || upperMethod === 'DELETE' ? undefined : body,
      headers: httpHeaders,
      params: httpParams,
      observe: 'response',
      responseType: wantsBlob ? 'blob' : 'json'
    }) as Observable<HttpResponse<any>>;

    return req$.pipe(
      map((res: HttpResponse<any>) => {
        if (wantsBlob && res.body instanceof Blob) {
          const fileName = this.fileNameFromContentDisposition(
            res.headers.get('Content-Disposition'),
            'download.bin'
          );
          return {
            status: res.status,
            statusText: res.statusText,
            body: { message: 'Binary file received', fileName, size: res.body.size },
            blob: res.body,
            fileName
          };
        }
        return { status: res.status, statusText: res.statusText, body: res.body };
      }),
      catchError((err: HttpErrorResponse) => of(this.describeError(err, url)))
    );
  }

  private fileNameFromContentDisposition(header: string | null, fallback: string): string {
    if (!header) return fallback;
    const match = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(header);
    return match ? decodeURIComponent(match[1].replaceAll('"', '').trim()) : fallback;
  }

  /**
   * Turns a failed request into something readable.
   *
   * When a request never reaches the server — the service is down, the host is wrong, or CORS
   * blocked it — Angular reports status 0 and sets `error` to a DOM ProgressEvent. Passing that
   * straight through renders as `{"isTrusted": true}`, which tells the reader nothing. Replace it
   * with the actual diagnosis and the URL that was attempted.
   */
  private describeError(err: HttpErrorResponse, url: string): { status: number; statusText: string; body: any } {
    const isNetworkFailure = err.status === 0 || err.error instanceof ProgressEvent || err.error instanceof Event;

    if (isNetworkFailure) {
      let host = url;
      try { host = new URL(url).origin; } catch { /* keep the raw url */ }
      return {
        status: 0,
        statusText: 'Could not reach the server',
        body: {
          error: 'The request never reached the server.',
          attemptedUrl: url,
          likelyCauses: [
            `Nothing is listening on ${host}`,
            'The browser blocked the call with a CORS policy',
            'The host or port is wrong for the environment you selected'
          ]
        }
      };
    }

    return { status: err.status, statusText: err.statusText, body: err.error };
  }

}
